<template>
    <div class="input-control">
        <div class="box-wrapper">
            <div class="box">
                <div v-if="personData.gid !== null">
                    <dynamic-display :load-data-api="getLoadEntityApi()" @loadEnd="onLoadEnd"
                                     :load-data-on-created="true" ref="dynamicDisplay" class="dynamic-display">
                        <template v-slot:showResultsContainer>
                            <div v-if="personDetail">
                                <div class="card">
                                    <div class="person-main-header">
                                        <h1>{{ personDetail.nameEn }} {{ personDetail.nameCh }}</h1>
                                        <div>
                                            <a href="#" @click.prevent="reviewPerson(personData.gid)">Review</a>
                                        </div>
                                    </div>
                                    <div>
                                        <span v-if="personDetail.gender">{{ personDetail.gender }}</span>
                                        <span v-if="personDetail.gender&&personDetail.birthday">, </span>
                                        <span v-if="personDetail.birthday">Born {{ personDetail.birthday }}</span>
                                        <span class="text-gray"> (ID: {{ personData.gid }})</span>
                                    </div>
                                    <div class="sections">
                                        <div class="section">
                                            <div class="section-header">
                                                Capacity Codes
                                            </div>
                                            <div class="section-body">
                                                <template
                                                        v-if="personDetail.capacityCodes && personDetail.capacityCodes.length">
                                                    <div class="codes-container">
                                                        {{ personDetail.capacityCodes.join(', ') }}
                                                    </div>
                                                </template>
                                                <template v-else>None</template>
                                            </div>
                                        </div>
                                        <div class="section">
                                            <div class="section-header with-controls">
                                                <div class="header-text">
                                                    Capacity (Linked Only)
                                                </div>
                                                <simple-dropdown :dropdown-arrow="true" class="more-info-dropdown"
                                                                 :alignment="1" :click-dropdown-menu-to-hide="false"
                                                                 @dropdownMenuShown="onAddCapacityDropdownShow"
                                                                 ref="addCapacityDropdown"
                                                >
                                                    <template v-slot:triggerButtonContent>
                                                        <button class="icon-button"><i class="gf gf-add"></i></button>
                                                    </template>
                                                    <template v-slot:dropdownMenu>
                                                        <div class="dropdown-content">
                                                            <div class="add-index-id-dropdown">
                                                                <div class="header">Add New Linked Capacity:</div>
                                                                <input type="text" placeholder="Input an index ID"
                                                                       ref="capacityIndexIdInputField"
                                                                       @keydown.enter="tryAddCapacityIndexId"
                                                                >
                                                                <button class="button-primary"
                                                                        @click="tryAddCapacityIndexId">
                                                                    Add
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </simple-dropdown>
                                            </div>
                                            <div class="section-body">
                                                <div class="list-items" v-if="personData.capacity_index_ids.length">
                                                    <capacity-row class="list-item"
                                                                  v-for="(item) in personData.capacity_index_ids"
                                                                  :key="item"
                                                                  :index-id="item"
                                                                  @removeItem="tryRemoveCapacityIndexId"
                                                                  ref="capacityRows"
                                                    ></capacity-row>
                                                </div>
                                                <div v-else>None</div>
                                            </div>
                                        </div>
                                        <div class="section">
                                            <div class="section-header with-controls">
                                                <div class="header-text">
                                                    Person Bio (Linked Only)
                                                </div>
                                                <simple-dropdown :dropdown-arrow="true" class="more-info-dropdown"
                                                                 :alignment="1" :click-dropdown-menu-to-hide="false"
                                                                 @dropdownMenuShown="onAddPersonBioDropdownShow"
                                                                 ref="addPersonBioDropdown"
                                                >
                                                    <template v-slot:triggerButtonContent>
                                                        <button class="icon-button"><i class="gf gf-add"></i></button>
                                                    </template>
                                                    <template v-slot:dropdownMenu>
                                                        <div class="dropdown-content">
                                                            <div class="add-index-id-dropdown">
                                                                <div class="header">Add New Linked Person Bio:</div>
                                                                <input type="text" placeholder="Input an index ID"
                                                                       ref="personBioIndexIdInputField"
                                                                       @keydown.enter="tryAddPersonBioIndexId"
                                                                >
                                                                <button class="button-primary"
                                                                        @click="tryAddPersonBioIndexId">
                                                                    Add
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </simple-dropdown>
                                            </div>
                                            <div class="section-body">
                                                <div class="list-items" v-if="personData.person_bio_index_ids.length">
                                                    <person-bio-row class="list-item"
                                                                    v-for="(item) in personData.person_bio_index_ids"
                                                                    :key="item"
                                                                    :index-id="item"
                                                                    @removeItem="tryRemovePersonBioIndexId"
                                                                    ref="personBioRows"
                                                    ></person-bio-row>
                                                </div>
                                                <div v-else>None</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>The person "{{ personData.gid }}" doesn't exist in AdminHK</div>
                        </template>
                    </dynamic-display>
                    <div class="text-right mt-3">
                        <button class="w-100" @click="goPersonFinderScene">Link to Another Person</button>
                    </div>
                </div>
                <div v-show="personData.gid === null" class="person-finder-scene">
                    <h5 class="mb-2">Link to a Person in AdminHK</h5>
                    <div class="search-box-header">
                        <div class="header-text">Search for a Person</div>
                        <a href="#" @click.prevent="openWindowForNewPerson">New Person</a>
                    </div>
                    <div class="search-box-container">
                        <input type="text" @input="onPersonSearchFieldInput"
                               ref="searchField" v-focus
                               placeholder="Search by name, stock code, Gekko ID, etc"
                        >
                        <i class="gf gf-search search-icon"></i>
                    </div>
                    <div class="search-results-container" v-if="searchPersonManager.showResultsContainer">
                        <template v-if="searchPersonManager.isLoading">
                            <div class="search-state">Loading...</div>
                        </template>
                        <template v-else-if="searchPersonManager.showSuggestedItems">
                            <div class="search-state">
                                {{ searchPersonManager.suggestionItems.length }} Suggestion(s)
                            </div>
                            <div class="table-container">
                                <table class="light-table">
                                    <thead>
                                    <tr>
                                        <th class="column-action">
                                            <div class="content"></div>
                                        </th>
                                        <th>
                                            <div class="content">Name</div>
                                        </th>
                                        <th>
                                            <div class="content">Birthday</div>
                                        </th>
                                        <th>
                                            <div class="content">Gender</div>
                                        </th>
                                      <th>
                                        <div class="content">Capacity Codes</div>
                                      </th>
                                      <th>
                                        <div class="content">Owned Codes</div>
                                      </th>
                                      <th>
                                        <div class="content">Traded Codes</div>
                                      </th>
                                      <th>
                                        <div class="content">Other Names</div>
                                      </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in searchPersonManager.suggestionItems" :key="index">
                                        <td class="column-action">
                                            <div class="content">
                                                <div class="mb-1">
                                                    <button @click="selectPerson(item)">Select</button>
                                                </div>
                                                <div>
                                                    <button @click="reviewPerson(item.gid)">Review</button>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="content">
                                                <div v-html="item.nameEn" class="text-nowrap"></div>
                                                <div v-html="item.nameCh" class="text-nowrap"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="content">{{ item.birthday }}</div>
                                        </td>
                                        <td>
                                            <div class="content">{{ item.gender }}</div>
                                        </td>
                                        <td>
                                            <div class="content">
                                                <div v-if="item.capacityCodes" class="codes-container"
                                                     :title="item.capacityCodes.join(', ')">
                                                <span class="code-item" v-for="(item,index) in item.capacityCodes"
                                                      :key="index">{{ item }}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="content">
                                                <div v-if="item.ownedCodes" class="codes-container"
                                                     :title="item.ownedCodes.join(', ')">
                                                <span class="code-item" v-for="(item,index) in item.ownedCodes"
                                                      :key="index">{{ item }}</span>
                                                </div>
                                            </div>
                                        </td>
                                      <td>
                                        <div class="content">
                                          <div v-if="item.tradedCodes" class="codes-container"
                                               :title="item.tradedCodes.join(', ')">
                                                <span class="code-item" v-for="(item,index) in item.tradedCodes"
                                                      :key="index">{{ item }}</span>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <div class="content">
                                          <div v-if="item.personOtherNames">
                                            <span v-text="item.personOtherNames.join(', ')"></span>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                        <template v-else-if="searchPersonManager.showEmptyIndicator">
                            <div class="search-state">No results found</div>
                        </template>
                        <template v-else-if="searchPersonManager.meetLoadingError">
                            <div class="search-state">An error occurred. Try again later.</div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputControlBase from "@/InputControls/InputControlBase";
import DynamicDisplay from "@/components/DynamicDisplay";
import SimpleDropdown from "@/components/SimpleDropdown";
import CapacityRow from "@/components/CapacityRow";
import {getPersonBioData, getPersonCapacityData, getSuggestedEntities} from "@/apis";
import {
    genRanHex,
    getAppropriateNoun,
    getDataPointInSuggestionItem,
    getReviewPersonLinkToAdminHK,
    tempIdProvider
} from "@/utils";
import {createPersonLink} from "@/config/constants";
import PersonBioRow from "@/components/PersonBioRow";

const cardTypes = {
    capacity: 0,
    person_bio: 1,
}

export default {
    name: "PersonCapacityBox",
    components: {PersonBioRow, CapacityRow, SimpleDropdown, DynamicDisplay},
    mixins: [InputControlBase],
    props: {},
    data() {
        return {
            searchPersonManager: {
                showResultsContainer: null,
                suggestionItems: null,
                currentlyLoadingKeywords: null,
                isLoading: null,
                meetLoadingError: null,
                showSuggestedItems: null,
                showEmptyIndicator: null,
            },
            adminHKRequestID: null,
            personData: {
                gid: null,
                capacity_index_ids: [],
                person_bio_index_ids: [],
            },
            personDetail: null,
        }
    },
    created() {
        this.repaintUI();
    },
    mounted() {
        window.addEventListener('message', this.handleMessage);
    },
    destroyed() {
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        valueWillChange() {
            if (this.personData.gid === null) {
                this.value = null;
            } else {
                const {gid, capacity_index_ids, person_bio_index_ids} = this.personData;
                this.value = {
                    gid,
                    capacity_index_ids: [...capacity_index_ids],
                    person_bio_index_ids: [...person_bio_index_ids],
                }
            }
        },
        repaintUI() {
            if (this.value) {
                const {gid, capacity_index_ids, person_bio_index_ids} = this.value;
                this.personData = {
                    gid,
                    capacity_index_ids: [...capacity_index_ids],
                    person_bio_index_ids: [...person_bio_index_ids],
                }
            } else {
                this.personData = {
                    gid: null,
                    capacity_index_ids: [],
                    person_bio_index_ids: [],
                }
            }
        },
        setInputValue(value) {
            this.value = value;
            this.repaintUI();
        },
        focus() {

        },
        getLoadEntityApi() {
            return getSuggestedEntities.bind(null, this.personData.gid, 1, undefined, true);
        },
        onLoadEnd(showingResults, results) {
            if (results && results.length) {
                this.personDetail = this.transformSuggestionItem(results[0]);
            } else {
                this.personDetail = null;
            }
        },
        reviewPerson(gid) {
            let url = getReviewPersonLinkToAdminHK(gid);
            this.openWindowHelper(url);
        },
        transformSuggestionItem(item) {
            item = {
              _source: item,
            }
          let nameEn = getDataPointInSuggestionItem(item, 'Gekko_fullname');
          let nameCh = getDataPointInSuggestionItem(item, 'Gekko_ch');
          let birthday = getDataPointInSuggestionItem(item, 'Birthday');
          let gender = getDataPointInSuggestionItem(item, 'Gender');
          let capacityCodes = getDataPointInSuggestionItem(item, 'Stock_code', false);
          let ownedCodes = getDataPointInSuggestionItem(item, 'owned_codes', false);
          let tradedCodes = getDataPointInSuggestionItem(item, 'traded_codes', false);
          let gid = getDataPointInSuggestionItem(item, 'Gekko_id_person');
          let personOtherNames = getDataPointInSuggestionItem(item, 'person_other_names', false);

          capacityCodes && capacityCodes.sort();
          ownedCodes && ownedCodes.sort();
          tradedCodes && tradedCodes.sort();
          return {
            nameEn,
            nameCh,
            birthday,
            gender,
            capacityCodes,
            ownedCodes,
            tradedCodes,
            gid,
            personOtherNames,
          }
        },
        openWindowHelper(url) {
            this.moveAdminHKRequestID();
            return window.open(`${url}${url.indexOf('?') >= 0 ? '&' : '?'}clk_source=da2&req=${this.adminHKRequestID}`, '', 'width=1200,height=800,menubar=yes,location=no,resizable=yes,scrollbars=yes,status=yes')
        },
        moveAdminHKRequestID() {
            this.adminHKRequestID = tempIdProvider(genRanHex(32));
        },
        onPersonSearchFieldInput() {
            this.trySearchPersonEntities();
        },
        trySearchPersonEntities() {
            const searchField = this.$refs.searchField;

            const value = searchField.value.trim();

            if (value === this.searchPersonManager.currentlyLoadingKeywords) {
                return;
            }

            if (!value) {
                this.hideSearchPersonResultsContainer();
                return;
            }

            if (this.searchPersonManager.showResultsContainer) {
                this.searchPersonManager.currentlyLoadingKeywords = value;
            } else {
                this.setSearchPersonManagerData(true, null, value, true, false, false, false)
            }

            getSuggestedEntities(value, 20, 'person', true).then(r => {
                if (this.searchPersonManager.currentlyLoadingKeywords !== value) {
                    return;
                }
                const data = this.transformSuggestionsData(r.data);
                this.setSearchPersonManagerData(true, data, null, false, false, data.length, !data.length);
            }).catch(err => {
                if (value !== this.searchPersonManager.currentlyLoadingKeywords) {
                    return;
                }
                this.setSearchPersonManagerData(true, null, null, false, true, false, false);
                this.handleServerSideError(err).catch(() => {

                })
            })
        },
        setSearchPersonManagerData(showResultsContainer, suggestionItems, currentlyLoadingKeywords, isLoading, meetLoadingError, showSuggestedItems, showEmptyIndicator) {
            this.searchPersonManager.showResultsContainer = showResultsContainer;
            this.searchPersonManager.suggestionItems = suggestionItems;
            this.searchPersonManager.currentlyLoadingKeywords = currentlyLoadingKeywords;
            this.searchPersonManager.isLoading = isLoading;
            this.searchPersonManager.meetLoadingError = meetLoadingError;
            this.searchPersonManager.showSuggestedItems = showSuggestedItems;
            this.searchPersonManager.showEmptyIndicator = showEmptyIndicator;
        },
        hideSearchPersonResultsContainer() {
            this.setSearchPersonManagerData(false, null, null, null, null, null, null);
        },
        transformSuggestionsData(responseData) {
            const data = [];
            for (let item of responseData) {
                data.push(this.transformSuggestionItem(item));
            }
            return data;
        },
        selectPerson(item) {
            this.handlePersonData(item.gid);
        },
        goPersonFinderScene() {
            this.handlePersonData(null);
            this.$nextTick(() => {
                this.$refs.searchField.focus();
            })
        },
        openWindowForNewPerson() {
            this.openWindowHelper(createPersonLink);
        },
        handleMessage(event) {
            let data = event.data;
            if (data && data instanceof Object &&
                    data.action === 'da2link_done' &&
                    data['req'] === this.adminHKRequestID && (data = data['da2_table_changes_helper'])) {
                this.adminHKRequestID = null;
                this.handlePersonData(data['person_id'], data['capacity_index_ids'], data['person_bio_index_ids']);
                event.source.close();
            }
        },
        handlePersonData(gid, capacity_index_ids, person_bio_index_ids) {
            if (gid === null) {
                this.personData = {
                    gid: null,
                    capacity_index_ids: [],
                    person_bio_index_ids: [],
                }
                this.valueWillChange();
                return
            }

            gid = parseInt(gid);
            capacity_index_ids = capacity_index_ids || [];
            person_bio_index_ids = person_bio_index_ids || [];

            let addedCapacityLinks = 0;
            let addedPersonBioLinks = 0;
            let isNewPerson = false;

            if (gid === this.personData.gid) {
                // it's the same person, so simply update the index ids...
                capacity_index_ids.forEach(index_id => {
                    if (this.personData.capacity_index_ids.indexOf(index_id) === -1) {
                        this.personData.capacity_index_ids.push(index_id);
                        addedCapacityLinks++;
                    }
                });
                person_bio_index_ids.forEach(index_id => {
                    if (this.personData.person_bio_index_ids.indexOf(index_id) === -1) {
                        this.personData.person_bio_index_ids.push(index_id);
                        addedPersonBioLinks++;
                    }
                })
            } else {
                // it's a new person
                isNewPerson = true;
                this.personData = {
                    gid: gid,
                    capacity_index_ids: capacity_index_ids,
                    person_bio_index_ids: person_bio_index_ids,
                }
                addedCapacityLinks = capacity_index_ids.length;
                addedPersonBioLinks = person_bio_index_ids.length;
            }

            this.notifyChanges(isNewPerson, addedCapacityLinks, addedPersonBioLinks);
            this.valueWillChange();
        },
        notifyChanges(isNewPerson, addedCapacityLinks, addedPersonBioLinks) {
            function describeChange(change, topic) {
                let m;
                if (change > 0) {
                    m = 'added ';
                } else {
                    m = 'removed '
                }
                return m + Math.abs(change) + ' ' + getAppropriateNoun(topic, change);
            }

            let message = '';
            if (isNewPerson) {
                message += `Selected person "${this.personData.gid}"`
                if (addedCapacityLinks || addedPersonBioLinks) {
                    message += ` with ${addedCapacityLinks} Capacity ${getAppropriateNoun('link', addedCapacityLinks)}, ${addedPersonBioLinks} Person Bio ${getAppropriateNoun('link', addedPersonBioLinks)}`
                }
            } else if (addedCapacityLinks || addedPersonBioLinks) {
                if (addedCapacityLinks) {
                    message += describeChange(addedCapacityLinks, 'Capacity link');
                }
                if (addedPersonBioLinks) {
                    if (message) {
                        message += ', '
                    }
                    message += describeChange(addedPersonBioLinks, 'Person Bio link');
                }
                message = message[0].toUpperCase() + message.substr(1);
            }
            if (message) {
                this.$toasted.show(message, {duration: 3000})
            }
        },
        onAddCardDropdownShow(cardType) {
            this.$nextTick(() => {
                let target;
                switch (cardType) {
                    case cardTypes.capacity:
                        target = this.$refs.capacityIndexIdInputField;
                        break;
                    case cardTypes.person_bio:
                        target = this.$refs.personBioIndexIdInputField;
                        break;
                    default:
                        throw new Error('Invalid card type: ' + cardType)
                }
                target.value = '';
                setTimeout(() => {
                    target.focus();
                }, 0);
            })
        },
        onAddCapacityDropdownShow() {
            this.onAddCardDropdownShow(cardTypes.capacity);
        },
        onAddPersonBioDropdownShow() {
            this.onAddCardDropdownShow(cardTypes.person_bio)
        },
        tryAddCardIndexId(cardType) {
            let inputField, dropdown, index_ids, indexIdFinder, cardRowsKeyName;
            switch (cardType) {
                case cardTypes.capacity:
                    inputField = this.$refs.capacityIndexIdInputField;
                    dropdown = this.$refs.addCapacityDropdown;
                    index_ids = this.personData.capacity_index_ids;
                    indexIdFinder = getPersonCapacityData;
                    cardRowsKeyName = 'capacityRows';
                    break;
                case cardTypes.person_bio:
                    inputField = this.$refs.personBioIndexIdInputField;
                    dropdown = this.$refs.addPersonBioDropdown;
                    index_ids = this.personData.person_bio_index_ids;
                    indexIdFinder = getPersonBioData;
                    cardRowsKeyName = 'personBioRows';
                    break;
                default:
                    throw new Error('Invalid card type: ' + cardType);
            }
            const value = inputField.value.trim();
            if (!value) {
                inputField.focus();
                return
            }
            const number = parseInt(value);
            if (number.toString() !== value) {
                this.$toasted.show(`"${value}" doesn't seem like a valid Index ID!`, {duration: 3000})
                inputField.focus();
                inputField.selectionStart = 0;
                inputField.selectionEnd = value.length;
                return
            }
            if (index_ids.indexOf(number) >= 0) {
                this.$toasted.show(`${value} already linked!`, {duration: 3000})
                inputField.focus();
                inputField.selectionStart = 0;
                inputField.selectionEnd = value.length;
                return
            }
            let cont = true;
            indexIdFinder(value, this.personData.gid).then(r => {
                const data = r.data;
                if (!data) {
                    cont = false;
                    this.$toasted.show(`Index ID "${value}" doesn't exist for the person in AdminHK!`, {duration: 3000})
                }
            }).always(() => {
                if (cont) {
                    index_ids.push(number);
                    dropdown.toggleDropdownMenu(false);
                    this.$nextTick(() => {
                        const cardRows = this.$refs[cardRowsKeyName];
                        for (let i = 0; i < cardRows.length; i++) {
                            if (cardRows[i].indexId === number) {
                                cardRows[i].focus();
                                break;
                            }
                        }
                    })
                    this.notifyChanges(false, cardType === cardTypes.capacity ? 1 : 0, cardType === cardTypes.person_bio ? 1 : 0);
                    this.valueWillChange();
                }
            })
        },
        tryAddCapacityIndexId() {
            this.tryAddCardIndexId(cardTypes.capacity)
        },
        tryAddPersonBioIndexId() {
            this.tryAddCardIndexId(cardTypes.person_bio);
        },
        tryRemoveCardIndexId(cardType, indexId) {
            let index_ids;
            switch (cardType) {
                case cardTypes.capacity:
                    index_ids = this.personData.capacity_index_ids;
                    break;
                case cardTypes.person_bio:
                    index_ids = this.personData.person_bio_index_ids;
                    break;
                default:
                    throw new Error('Invalid card type: ' + cardType);
            }

            index_ids.splice(index_ids.indexOf(indexId), 1);
            this.notifyChanges(false, cardType === cardTypes.capacity ? -1 : 0, cardType === cardTypes.person_bio ? -1 : 0);
            this.valueWillChange();
        },
        tryRemoveCapacityIndexId(indexId) {
            this.tryRemoveCardIndexId(cardTypes.capacity, indexId);
        },
        tryRemovePersonBioIndexId(indexId) {
            this.tryRemoveCardIndexId(cardTypes.person_bio, indexId);
        },
    },
}
</script>

<style scoped lang="scss">
@import "input-controls";
@import "../assets/variables";

h1 {
    font-weight: 500;
    font-size: 19px;
    margin-top: 0;
}

h5 {
    margin-top: 0;
    font-weight: 600;
    font-size: inherit;
}

.search-box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.32rem;
}

.search-box-container {
    position: relative;

    input {
        width: 100%;
        padding-left: 1.25rem;
    }

    .search-icon {
        position: absolute;
        left: 4px;
        top: 3px;
        color: gray;
        font-size: 15px;
    }
}

.search-results-container {
    margin-top: 1rem;
}

.search-state {
    color: gray;
    margin-bottom: 0.25rem;
}

.table-container {
    overflow: auto;
    border: 1px solid lightgray;
    max-height: 420px;

    table {
        min-width: 100%;

        thead {
            .column-action {
                .content {
                    min-height: 20px;
                }
            }
        }

        th {
            background-color: #f3f3f3;
        }

        tbody {
            .column-action {
                button {
                    font-size: 0.86em;
                    min-width: 62px;
                }
            }
        }
    }

    .codes-container {
        overflow: auto;
        max-height: 74px;

        .code-item {
            margin-bottom: 4px;
            font-size: 0.86em;
            background-color: gray;
            color: white;
            border-radius: 4px;
            padding: 1px 4px;
            font-weight: 500;
            line-height: 16px;
            display: block;
            width: 50px;
            text-align: center;
        }
    }
}

.card {
    border: 1px solid lightgray;
    border-radius: 4px;
    padding: 0.75rem 1rem;
    background-color: white;

    .codes-container {
        line-height: 18px;
        max-height: 45px;
        overflow: auto;
    }
}

.person-main-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    h1 {
        margin-bottom: 0.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 0.5rem;
    }

    a {
        white-space: nowrap;
    }
}

.sections {
    margin-top: 2rem;

    .section {
        margin-top: 1rem;
        margin-right: -1rem;
        padding-right: 1rem;

        .section-header {
            font-weight: 600;
            margin-bottom: 0.5rem;
            color: gray;

            &.with-controls {
                display: flex;
                align-items: center;
                justify-content: space-between;

                button {
                    font-size: 0.86em;
                }
            }
        }

        &:not(:last-child) {
            border-bottom: 1px solid #e0e0e0;
            padding-bottom: 1rem;
        }
    }
}

.list-item {
    &:not(:last-child) {
        margin-bottom: 1rem;
    }

    &:first-child {
        margin-top: 14px;
    }
}

.description {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.86em;
    margin-bottom: 0.5rem;
    margin-top: -0.5rem;

    .description-content {
        background-color: white;
        border-radius: 6px;
        padding: 2px 0.5rem;
    }
}

.more-info {
    margin: -0.75rem 0 0.5rem;
    display: flex;
    justify-content: center;
}

a {
    color: $primary-purple;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.add-index-id-dropdown {
    padding: 0.75rem 0.75rem;

    .header {
        margin-bottom: 0.25rem;
    }

    input {
        width: 220px;
        margin-right: 0.25rem;
    }
}
</style>

<style lang="scss">
.person-finder-scene {
    .highlight {
        font-weight: normal;
    }
}
</style>
